<template>
  <transition name="slide-to-bottom">
    <div class="cookies-alert" v-if="!accepted">
      <div class="close" @click="accept">
        <IconCross/>
      </div>
      <div class="icon">
        <IconCookie/>
      </div>
      <p v-html="$t('cookiesText')" class="text"></p>
      <BaseButton theme="red" size="sm"
                  style="padding-left:2rem;padding-right:2rem; "
                  @click="accept">
        {{ $t('ok') }}
      </BaseButton>
    </div>
  </transition>
</template>

<script>
import IconCross from "@/components/icons/IconCross";
import BaseButton from "@/components/UI/BaseButton";
import IconCookie from "@/components/icons/IconCookie";

export default {
  name: "CookiesAlert",
  components: {IconCookie, BaseButton, IconCross},
  data() {
    return {
      accepted: false,
    }
  },
  methods: {
    accept() {
      this.$cookies.set('_cookies-accepted', true, '365D')
      this.accepted = true;
    }
  },
  created() {
    this.accepted = !!this.$cookies.get('_cookies-accepted')
  },
  i18n: {
    messages: {
      en: {
        cookiesText: 'We are using <a href="/en/legal/privacy-policy">cookie files</a>. No way without them.🤷🏼‍♂️',
        ok: 'Ok'
      },
      ru: {
        cookiesText: 'Мы используем <a href="/ru/legal/privacy-policy">файлы cookie</a>. Без них никак.',
        ok: 'Ок'
      }
    }
  },
}
</script>

<style lang="scss">
.cookies-alert {
  @apply fixed bottom-12 right-12 bg-block rounded py-8 px-10 text-center flex flex-col items-center shadow-primaryBlock;
  width: 370px;

  .close {
    @apply absolute right-8 top-8 text-red cursor-pointer transition duration-200;
    &:hover {
      @apply text-red-hover;
    }
  }

  .icon {
    @apply text-text-ternary bg-line flex items-center justify-center rounded-full mb-8;
    width: 3.4rem;
    height: 3.4rem;
  }

  .text {
    @apply text-md text-text mb-8 font-medium;
    a {
      @apply border-b border-border transition duration-200;
      &:hover {
        @apply border-red text-red;
      }
    }
  }
  @media(max-width: 767.98px){
    @apply right-0 left-0 mx-auto;
    width: 300px;
  }
}

.slide-to-bottom-leave-active,
.slide-to-bottom-enter-active {
  transition: .5s;
}

.slide-to-bottom-enter {
  transform: translate(0, 0);
  opacity: 1;
}

.slide-to-bottom-leave-to {
  transform: translate(0, 50%);
  opacity: 0;
}
</style>